<template>
	<nk-box
		v-if="user && context.menuItems && context.menuItems.length"
		variant="sidebar"
	>
		<nk-title size="lg">
			{{ context.title || 'Menü' }}
		</nk-title>
		<hr />
		<nk-drilldown :menu-items="context.menuItems" />
	</nk-box>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 * @prop {string} context.title
 * @prop {array} context.menuItems
 */
export default {
	name: 'NkSidebarRatsinfosystem',

	mixins: [TemplatesDefault],

	computed: {
		user() {
			return this.$store.state.nuxtKommunen.ratsinfoauth.user;
		},
	},
};
</script>
